import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, GradeOptions } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/homework-sources/HomeworkSourcesAction";
import { useHomeworkSourcesUIContext } from "../HomeworkSourcesUIContext";

const prepareFilter = (queryParams, values) => {
  let { grade, courseId, name, pageNumber } = values;
  pageNumber = pageNumber === "" ? null : pageNumber;
  const newQueryParams = { ...queryParams };
  const filter = { grade, courseId, name, pageNumber };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function HomeworkSourcesFilter() {
  // Homework Sources UI Context
  const sourcesUIContext = useHomeworkSourcesUIContext();
  const sourcesUIProps = useMemo(() => {
    return {
      setQueryParams: sourcesUIContext.setQueryParams,
      queryParams: sourcesUIContext.queryParams,
    };
  }, [sourcesUIContext]);
  
  const dispatch = useDispatch();
  const { courses } = useSelector(
    (state) => ({
      courses: state.homeworkSources.courses
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getCourses());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(sourcesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, sourcesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      sourcesUIProps.setQueryParams(newQueryParams);
    }
  };

  const gradeOptions = FilterOptions.concat(GradeOptions);
  const courseOptions = FilterOptions.concat(courses);
  
  return (
    <Formik
      initialValues={{
        name: "",
        pageNumber: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <CustomSelect 
                options={gradeOptions}
                value={values.grade}
                placeholder="Sınıf"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("grade", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sınıf</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={courseOptions}
                value={values.courseId}
                placeholder="Ders"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("courseId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Ders</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Kaynak Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kaynak Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="number"
                className="form-control"
                name="pageNumber"
                min={1}
                placeholder="Sayfa Numarası"
                onBlur={handleBlur}
                value={values.pageNumber}
                onChange={(e) => {
                  setFieldValue("pageNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Sayfa Numarası</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}